import React, { Component } from 'react';
import HeaderPage from '../projectmgmt/header/Header';
import AksharLeftPanel from './AksharLeftPanel';

class AksharMainPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        {/* Navbar */}
        <div id="navBar">
          <HeaderPage />
        </div>
        {/* Left panel */}
        <div className="content-wrapper" id="leftPanel" >

          <AksharLeftPanel />
          {/* <LeftPanel />  */}
        </div>
      </div>
    );
  }
}

export default AksharMainPage;


// WEBPACK FOOTER //
// ./src/aksharUi/AksharMainPage.js